import { render, staticRenderFns } from "./EditServiceTicketDetail.vue?vue&type=template&id=b32e179e&"
import script from "./EditServiceTicketDetail.vue?vue&type=script&lang=js&"
export * from "./EditServiceTicketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports